import { render } from "./EstadoPagoList.vue?vue&type=template&id=8c48c540&scoped=true"
import script from "./EstadoPagoList.vue?vue&type=script&lang=js"
export * from "./EstadoPagoList.vue?vue&type=script&lang=js"

import "./EstadoPagoList.vue?vue&type=style&index=0&id=8c48c540&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c48c540"]])

export default __exports__